(function ($, dateutils) {
	dateutils.currentYear = function () {
		return (new Date()).getFullYear();
	};
	
	dateutils.parseDate = function (date) {
		var parts = date.split('.');
		if (parts.length != 3)
			return null;
		return new Date(parts[2], parts[1] - 1, parts[0]);
	};
	
	dateutils.compareDates = function (date1, date2) {
		if (!(date1 instanceof Date)) {
			date1 = parseDate(date1);
		}
		if (!(date2 instanceof Date)) {
			date2 = parseDate(date2);
		}
		
		if (date1 == null || date2 == null) 
			return false;
		var t1 = date1.getTime();
		var t2 = date2.getTime();
		if (t1 > t2)
			return -1;
		else if (t1 < t2) 
			return 1;
		else
			return 0;
	};
	
	dateutils.today = function () {
		var d = new Date();
		d.setHours(0, 0, 0, 0);
		return d;
	};
} (jQuery, window.dateutils = window.dateutils || {}));